// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0507637d","453":"82d57fd9","732":"09ac3eca","977":"c37562f4"}[chunkId] + ".chunk.js";
};